import { Box } from '@material-ui/core'
import { Button } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import taxation from 'img/taxes-2.png'
import { editUserAttribute } from 'lib/api'
import { useConfirm } from 'lib/hooks'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

export const Settings = (): JSX.Element => {
  const { t } = useTranslation()
  const { user, fetchUser } = useUser()
  const history = useHistory()

  const enableMarginTaxation = async () => {
    await editUserAttribute(true, 'enableMarginTaxation')
    await fetchUser()
    history.push('/account?tab=taxation')
  }

  const [confirmSettings, ConfirmDialog] = useConfirm(
    t('taxation.settings.enableMarginSchemeTitle'),
    t('taxation.settings.enableMarginSchemeDescription'),
    enableMarginTaxation
  )

  return (
    <div className="taxation-root">
      <div id="settings">
        <div className="w-100 d-flex flex-column align-items-center mt-3">
          <img src={taxation} style={{ maxWidth: 600, width: '100%', height: 'auto' }} />
          <Box maxWidth={800} width="100%" px={2} className="text-center">
            <h2 className="fst-italic mt-3">{t('taxation.settings.defaultInfoSubtitle')}</h2>

            <div className="alert alert-warning">
              <div className="d-flex flex-row">
                <i className="fa-light fa-triangle-exclamation me-2 fs-5" />
                <p className="p-0 m-0">
                  <strong>{t('taxation.settings.important')}:</strong>{' '}
                  {t('taxation.settings.importantNote')}
                </p>
              </div>
            </div>

            <Button
              className="mt-3"
              variant="contained"
              data-testid={'enable-margin'}
              disabled={user.enableMarginTaxation}
              onClick={confirmSettings}
              scaleUp
            >
              {t('taxation.settings.enableMarginTaxation')}
            </Button>
          </Box>
        </div>
      </div>
      <ConfirmDialog />
    </div>
  )
}
